import TicketSelector from '../../../events/detail/TicketSelector';
import { TicketSelectorOptions } from '../../../events/detail/types';

export default class PackageDetailTicketSelector extends TicketSelector {
  constructor($form: HTMLFormElement, options: TicketSelectorOptions) {
    super($form, options);

    this.form.addEventListener('submit', this.preFormSubmit);
  }
}
